import { Gift } from 'lucide-react'
import { usePlanAllowances } from '@renderer/chat/hooks/use-plan-allowances'
import { PlanNote } from '@renderer/components/pricing/plan-note'
import { ranOnFreeGraceHour } from '../free-grace-hour'
import type { MeetingViewModel } from '../use-meeting-view-model'

/** On the finished meeting that ran on Free's one-time grace hour: the hour was a gift, so it says so. */
export function FreeGraceHourNote({ model }: { model: MeetingViewModel }) {
  const grantedAt = usePlanAllowances().data?.freeGraceHourGrantedAt
  const recording = model.variant === 'live' ? null : model.audioNote

  if (!ranOnFreeGraceHour(recording, grantedAt)) {
    return null
  }
  return (
    <PlanNote
      className="mx-3 mb-3"
      icon={<Gift />}
      title="We’re glad you’re using Highlight!"
      body="Enjoy one hour of extra meeting minutes, on us."
    />
  )
}
